import React, {useEffect, useRef, useState} from "react";
import {Bubble, H5, Justify} from "tea-component";
import AigcCoverImage from "@/pages/aigc/components/AigcCoverImage";
import "./index.scss";

interface AlignLayout {
  left?: React.ReactNode;
  right?: React.ReactNode;
}

interface ToolCardProps {
  cover: string; // 头部图片路径
  title: AlignLayout;
  subTitle: AlignLayout;
  content: React.ReactNode;
  footer: AlignLayout;
  className?: string;
}

export default function (props: ToolCardProps) {
  const { coverImgSrc, title, subTitle, content, footer, className, onClick } = props;
	
  // 卡片标题省略号时, hover有浮窗提示
  const [isView, setIsView] = useState(false);
  const textRef = useRef(null);
  useEffect(() => {
    if (textRef?.current?.scrollWidth > textRef?.current?.offsetWidth) {
      setIsView(true);
    }
  }, [textRef]);
	
  return (
    <div className={`tool-card-wrap ${className}`} onClick={onClick}>
      <div className={"tool-card"}>
        {/* <div className={"tool-cover"}>*/}
        <AigcCoverImage src={coverImgSrc} className={"tool-card-cover"}>
          {props.coverContent}
        </AigcCoverImage>
				
        {/* </div>*/}
				
        <div className={"tool-body"}>
          {
            title ? (<Justify
              key={"title"}
              className={"tool-card-title"}
              left={<>
							                  {title?.icon}
							                  <Bubble
								                  content={isView ? title?.text : ""}
								                  dark
							                  >
								                  <H5 ref={textRef}>{title?.text}</H5>
							                  </Bubble>
							                  {title?.left}
						                  </>}
              right={title?.right}
            />) : ""
          }
					
          {
            subTitle ? (<Justify key={"subTitle"} className={"tool-card-sub-title"} {...subTitle}/>) : ""
          }
          {
            content ? (<div className={"tool-card-content"}>
              {content}
            </div>) : ""
          }
          {
            footer ? (<Justify key={"footer"} className={"tool-card-footer"} {...footer}/>) : ""
          }
					
        </div>
      </div>
    </div>
  );
}

